import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'react-loader-spinner';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import SyncIcon from '@mui/icons-material/Sync';
import { useTranslation } from 'react-i18next';
import { connectionColorObj, spinnerCollors } from '../../../../themes';
import { useSensorReadingsContext } from '../../../../context/SensorReadingsContext';
import CustomTooltip from '../../../shared/atoms/CustomTooltip';
import { useLocationsCacheContext } from '../../../../context/LocationsCacheContext';

const ConfirmingDisplay = ({ confirming, mini, lastKnownDate, hasState }) => {
  const { connection } = useSensorReadingsContext();
  const { t, i18n } = useTranslation();

  const { isFetching: isFetchingLocationsCache } = useLocationsCacheContext();

  if (hasState && isFetchingLocationsCache)
    return (
      <CustomTooltip title={t('components.actuator_control_panel.syncing')}>
        <SyncIcon
          fontSize={mini ? 'small' : 'medium'}
          sx={{
            animation: 'spin 2s linear infinite',
            animationDirection: 'reverse',
            '@keyframes spin': {
              '0%': { transform: 'rotate(360deg)' },
              '100%': { transform: 'rotate(0deg)' },
            },
          }}
        />
      </CustomTooltip>
    );

  if (
    hasState &&
    connection.status === 'Disconnected' &&
    (confirming === 'failed' || confirming === false)
  )
    return (
      <CustomTooltip
        title={t(
          'components.actuator_control_panel.fail_to_confirm_disconnected',
          {
            lastKnownDate: lastKnownDate
              ? new Date(lastKnownDate).toLocaleString(i18n.language)
              : undefined,
          },
        )}
      >
        <SyncProblemIcon fontSize={mini ? 'small' : 'medium'} />
      </CustomTooltip>
    );

  let color = spinnerCollors.default;
  if (confirming === 'confirmed') {
    color = connectionColorObj.Connected;
  } else if (confirming === 'failed') {
    color = connectionColorObj.Error;
  } else if (confirming === 'confirming') {
    color = connectionColorObj.Connecting;
  }
  const size = mini ? 24 : 30;
  return (
    <Radio
      visible={confirming !== false}
      height={size}
      width={size}
      colors={[color, color, color]}
      wrapperStyle={{
        cursor: 'default',
        margin: '-10px -10px 0 10px',
      }}
    />
  );
};

ConfirmingDisplay.propTypes = {
  confirming: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
    .isRequired,
  mini: PropTypes.bool,
  lastKnownDate: PropTypes.string,
  hasState: PropTypes.bool,
};

export default ConfirmingDisplay;
